<template>
  <v-dialog v-model="open" max-width="1000" scrollable>
    <v-card>
      <v-card-title class="d-flex align-center justify-space-between">
        Kalendereinträge suchen
        <v-btn icon="mdi-close" variant="text" aria-label="Suche schließen" @click="open = false" />
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="8"><v-text-field v-model="query" label="Text in Titel oder Notiz" prepend-inner-icon="mdi-magnify" clearable autofocus variant="outlined" hide-details /></v-col>
          <v-col cols="12" sm="4"><v-select v-model="type" :items="types" label="Typ" clearable variant="outlined" hide-details /></v-col>
        </v-row>
        <p class="text-caption text-medium-emphasis my-3">Alle gespeicherten Kalendereinträge, unabhängig vom angezeigten Monat. Wiederholungen erscheinen einmal mit ihrem ursprünglichen Startdatum. Ohne Sportaktivitäten.</p>
        <v-alert v-if="error" type="error" variant="tonal" class="mb-3">{{ error }} <v-btn variant="text" size="small" @click="$emit('reload')">Erneut laden</v-btn></v-alert>
        <v-data-table :headers="headers" :items="results" :loading="loading" :items-per-page="10" :sort-by="[{ key: 'startDate', order: 'asc' }]" loading-text="Kalendereinträge werden geladen …" no-data-text="Keine passenden Kalendereinträge gefunden." density="comfortable">
          <template #item.name="{ item }"><v-btn variant="text" class="search-result-title" @click="$emit('select', item)">{{ item.name || 'Kalendereintrag' }}</v-btn></template>
          <template #item.startDate="{ item }">{{ formatDate(item.startDate) }}<span v-if="item.startTime"> · {{ item.startTime.slice(0, 5) }}</span></template>
          <template #item.endDate="{ item }">{{ formatDate(item.endDate) }}<span v-if="item.endTime"> · {{ item.endTime.slice(0, 5) }}</span></template>
          <template #item.recurrence="{ item }">{{ recurrenceLabels[item.recurrence] || item.recurrence }}</template>
        </v-data-table>
        <p class="text-caption mt-2" aria-live="polite">{{ results.length }} Treffer</p>
      </v-card-text>
      <v-card-actions><v-btn variant="text" @click="query = ''; type = null">Filter zurücksetzen</v-btn><v-spacer /><v-btn variant="text" @click="open = false">Schließen</v-btn></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CalendarSearchDialog',
  props: {
    modelValue: Boolean,
    entries: { type: Array, default: () => [] },
    loading: Boolean,
    error: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'select', 'reload'],
  data: () => ({
    query: '', type: null,
    recurrenceLabels: { none: 'Einmalig', daily: 'Täglich', weekly: 'Wöchentlich', monthly: 'Monatlich', yearly: 'Jährlich' },
    headers: [
      { title: 'Titel', key: 'name' }, { title: 'Typ', key: 'typeLabel' },
      { title: 'Beginn', key: 'startDate' }, { title: 'Ende', key: 'endDate' },
      { title: 'Wiederholung', key: 'recurrence' }, { title: 'Notiz', key: 'note', sortable: false },
    ],
  }),
  computed: {
    open: { get () { return this.modelValue }, set (value) { this.$emit('update:modelValue', value) } },
    rows () { return this.entries.map(entry => ({ ...entry, typeLabel: entry.isEvent ? entry.eventType || 'Termin' : 'Urlaub / Blocker' })) },
    types () { return [...new Set(this.rows.map(entry => entry.typeLabel))].sort((a, b) => a.localeCompare(b, 'de')) },
    results () {
      const terms = this.normalize(this.query).split(/\s+/).filter(Boolean)
      return this.rows.filter(entry => (!this.type || entry.typeLabel === this.type) && terms.every(term => this.normalize(`${entry.name} ${entry.note} ${entry.typeLabel}`).includes(term)))
    },
  },
  methods: {
    normalize (value) { return String(value || '').toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss') },
    formatDate (value) { const parts = String(value || '').slice(0, 10).split('-'); return parts.length === 3 ? parts.reverse().join('.') : '–' },
  },
}
</script>

<style scoped>
.search-result-title { text-transform: none; white-space: normal; height: auto; min-height: 36px; }
</style>
